var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "modals-global" } },
    [
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.success,
            expression: "modalState.success",
          },
        ],
        attrs: { container: "modal-container" },
        on: {
          close: function ($event) {
            return _vm.updateModal("success", false)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h3", { staticClass: "float-left" }, [
                  _vm._v("\n                Success\n            "),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close Modal" },
                    on: {
                      click: function ($event) {
                        return _vm.updateModal("success", false)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fas fa-times close-modal" })]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _vm.success_message
                  ? _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.success_message) },
                    })
                  : _c("p", [
                      _vm._v(
                        "\n                The action you performed was completed successfully."
                      ),
                      _c("br"),
                      _vm._v(
                        "\n                Thanks for using " +
                          _vm._s(_vm.product) +
                          ".\n            "
                      ),
                    ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.warning,
            expression: "modalState.warning",
          },
        ],
        attrs: { container: "modal-container" },
        on: {
          close: function ($event) {
            return _vm.updateModal("warning", false)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h3", { staticClass: "float-left" }, [
                  _vm._v("\n                Oops. Apologies.\n            "),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close Modal" },
                    on: {
                      click: function ($event) {
                        return _vm.updateModal("warning", false)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fas fa-times close-modal" })]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("code", {
                  domProps: { innerHTML: _vm._s(_vm.warning_message) },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.error,
            expression: "modalState.error",
          },
        ],
        attrs: { container: "modal-container" },
        on: {
          close: function ($event) {
            return _vm.updateModal("error", false)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h3", { staticClass: "float-left" }, [
                  _vm._v("\n                Oops. Apologies.\n            "),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close Modal" },
                    on: {
                      click: function ($event) {
                        return _vm.updateModal("error", false)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fas fa-times close-modal" })]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("p", [
                  _vm._v("There was an error making a request to our server."),
                ]),
                _vm._v(" "),
                _c("code", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.error_message) +
                      "\n            "
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.session_expired,
            expression: "modalState.session_expired",
          },
        ],
        attrs: { container: "modal-container" },
        on: { close: _vm.closeAndRedirect },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h3", { staticClass: "float-left" }, [
                  _vm._v(
                    "\n                Your session has expired.\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close Modal" },
                    on: { click: _vm.closeAndRedirect },
                  },
                  [_c("i", { staticClass: "fas fa-times close-modal" })]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _vm.session_expired_message
                  ? _c("code", [_vm._v(_vm._s(_vm.session_expired_message))])
                  : _c("code", [
                      _vm._v(
                        "\n                Your current session has expired. Please relogin and try again.\n            "
                      ),
                    ]),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-big btn-secondary mx-auto text-white",
                    attrs: { href: _vm.redirectUrl },
                  },
                  [_vm._v("\n                Go to Login page\n            ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.unpaid,
            expression: "modalState.unpaid",
          },
        ],
        attrs: { container: "modal-container" },
        on: {
          close: function ($event) {
            return _vm.updateModal("unpaid", false)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h3", { staticClass: "float-left" }, [
                  _vm._v(
                    "\n                Subscription Feature\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close Modal" },
                    on: {
                      click: function ($event) {
                        return _vm.updateModal("unpaid", false)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fas fa-times close-modal" })]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("p", [
                  _vm._v(
                    "\n                Unfortunately the requested feature is only available to\n                "
                  ),
                  _c("em", [_vm._v(_vm._s(_vm.product) + " subscribers")]),
                  _vm._v(
                    ". If you would like to\n                access this feature, get a subscription estimate now.\n            "
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-big btn-secondary mx-auto text-white",
                    attrs: { href: "/subscribe" },
                  },
                  [_vm._v("\n                Learn more\n            ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.unverified,
            expression: "modalState.unverified",
          },
        ],
        attrs: { container: "modal-container" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h3", { staticClass: "float-left" }, [
                  _vm._v("\n                Oops. Apologies.\n            "),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("p", [
                  _vm._v(
                    "\n                Unfortunately the requested feature is only available to verified account.\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                Our admin will verify your account and when it is done, you will receive the notification mail.\n            "
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }